import { File, FileArchive, FileAudio, FileImage, FileSpreadsheet, FileText, FileVideo } from "lucide-react";

export const size = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round((b || 0) / 1024))} KB`);
export const date = (s) => { try { return new Date(s).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }); } catch (e) { return ""; } };
export const iconFor = (f) => {
  const t = f.content_type || ""; const n = (f.name || "").toLowerCase();
  if (t.startsWith("image/")) return [FileImage, "text-[#0A66C2]"];
  if (t.startsWith("video/")) return [FileVideo, "text-[#7C3AED]"];
  if (t.startsWith("audio/")) return [FileAudio, "text-[#DB2777]"];
  if (/\.(zip|rar|7z)$/.test(n)) return [FileArchive, "text-[#92400E]"];
  if (/\.(xls|xlsx|csv)$/.test(n)) return [FileSpreadsheet, "text-[#15803D]"];
  if (/\.(pdf|doc|docx|txt|rtf|ppt|pptx)$/.test(n)) return [FileText, n.endsWith(".pdf") ? "text-[#E62314]" : "text-[#1D4ED8]"];
  return [File, "text-[#57534E]"];
};
export const tool = "flex h-8 w-8 items-center justify-center rounded hover:bg-black/10";
